import { getAuth } from "firebase/auth";
import { getApp, getApps } from "firebase/app";

// Debug function to check Firebase configuration
export const debugFirebaseConfig = () => {
    console.log("=== Firebase Debug Info ===");
    
    try {
        // Check if Firebase app is initialized
        const apps = getApps();
        console.log("Firebase apps:", apps);
        console.log("Number of Firebase apps:", apps.length);
        
        if (apps.length === 0) {
            console.error("❌ No Firebase apps initialized!");
            return false;
        }
        
        // Get the default app
        const app = getApp();
        console.log("Default Firebase app:", app);
        console.log("App name:", app.name);
        console.log("App options:", app.options);
        
        // Check auth
        const auth = getAuth();
        console.log("Auth instance:", auth);
        console.log("Auth app:", auth.app);
        console.log("Auth config:", auth.config);
        
        // Check if we have the required Firebase config
        const config: any = app.options;
        const requiredFields = ['apiKey', 'authDomain', 'projectId'];
        const missingFields = requiredFields.filter(field => !config[field]);
        
        if (missingFields.length > 0) {
            console.error("❌ Missing Firebase config fields:", missingFields);
            return false;
        }
        
        console.log("✅ Firebase appears to be properly configured");
        return true;
        
    } catch (error) {
        console.error("❌ Error checking Firebase config:", error);
        return false;
    }
};

// Call this function to test your Firebase setup
// You can call this in your Login component or wherever you initialize your app
// debugFirebaseConfig();